<template>
    <binary-function
        v-bind:expression="expression"
        v-bind:path="path"
        v-bind:function-name="functionName" />
</template>

<script setup>
    import binaryFunction from "./binaryFunction.vue";
    import { computed } from "vue";

    const props = defineProps({
        expression: { type: Object, required: true },
        path: {
            type: Array,
            required: false,
            default: () => []
        }
    });

    const functionName = computed(() => {
        const timeunits = props.expression.PropertyDictionary.timeunits;

        let funcStr = "DAYS BETWEEN";
        switch (timeunits) {
            case "calendar":
                funcStr = "CALENDAR DAYS BETWEEN";
                break;
            case "business":
                funcStr = "BUSINESS DAYS BETWEEN";
                break;
            default:
                break;
        }

        return funcStr;
    });
</script>
